<template>
    <div class="uk-padding" style="min-height: 85vh;">
        <div class="uk-container">
            <h1 class="uk-text-center">Message from the University President</h1>
            <h3 class="uk-text-center uk-text-capitalize">PROF. LINCOLN P. EDWARDS, DDS, PhD</h3>
            <div class="uk-padding">
                <h4 class="uk-heading-bullet" style="color: #033860; font-weight: bold">The Ambitions of the University to the Community and Society</h4>
                <div class="uk-panel">
                    <img class="uk-align-center uk-align-left@m uk-margin-remove-adjacent"  src="/LincolnEdwards.jpg"
                         style="border-radius: 15px; max-width: 300px; max-height: 300px; width: auto; height: auto;" >

                    <p class="uk-text-large"><br>
                        A new year has dawned, and 2020 is now truly hindsight. We thank God for allowing us
                        to weather the challenges of 2020, and our prayers extend to those who have lost
                        loved ones due to the pandemic or have their lives impacted in a negative way.
                    </p>
                    <p>
                        As we enter this second year of the second century of Northern Caribbean University (NCU) in
                        Manchester, we continue a profound and sustainable commitment to the total person through
                        values-based education that is underpinned by strong work ethics and an emphasis on innovation
                        and service.
                    </p>
                </div>


                <div class="uk-padding-small" style="background: rgba(179,229,252 ,0.5); border-radius: 15px">
                    <b>
                        This model of education has served Jamaica and the region well for 113 years, as
                        demonstrated in some notable achievements:
                    </b>
                    <ul>
                        <li>Four time winners of the National Business Model Competition (2014-2017)</li>
                        <li>First and only institution from the Caribbean and the second outside of
                            North America to win the International Business Model Competition (Provo, Utah, 2018). Fifth place was Johns Hopkins University. </li>
                        <li>
                            First and only institution from the Caribbean to win the Microsoft Imagine Cup (Poland, 2010).
                            The most prestigious technology competition in the world.
                        </li>
                        <li>
                            Second institution in Jamaica to receive institutional accreditation from the University Council of Jamaica.
                        </li>
                        <li>
                            Introduced cornflakes and vegetarian meat to Jamaica and processed both on the main campus.
                        </li>
                    </ul>
                </div>
                <br>
                <div class="uk-child-width-1-4@m" uk-grid>

                    <div><img src="../assets/32839895314_0a0469c65e_w.jpg" alt=""></div>


                    <div><img src="../assets/30732777378_2289090983_w.jpg" alt=""></div>

                    <!--<div><img src="../assets/accredit.jpg" alt=""></div>-->
                    <div><img src="../assets/igcup1.jpg" alt=""></div>
                    <div>
                        <img src="../assets/38568746041_20e97ef3ec_w.jpg" alt="">
                    </div>
                </div>
                <br>
                <div class="uk-padding-small" style="background: rgba(255,249,196 ,0.5); border-radius: 15px">
                    <p>
                        The good news is that this wholistic model of education is transforming students into vibrant, creative
                        and innovative individuals, ready to play a positive role in society and assume the mantle of leadership
                        in their chosen careers. NCU students are true champions, having won several sporting competitions such
                        as Division 2 football, and the Jamaica Intercollegiate Sports Association’s Junior Netball, and Male
                        and Female Badminton Championships. They have also placed, first and second in the Scientific Research
                        Council National Science and Technology Research Competition, and captured the coveted Prime Minister’s
                        Award for Innovation. All these achievements by our students clearly demonstrate that there is a way to
                        inspire young people and change their trajectory from negative choices leading to crime and violence, to
                        positive choices, leading to success, innovation and creativity.
                    </p>
                    <p>
                        For over a century, NCU has provided hope to many by championing the expansion of opportunities for
                        those with ability but no access, through the work and study programme, and by providing educational
                        and scholarship prospects through the generosity of alumni and friends. Consequently, in 2017, the
                        RESCUE (Restoring Every Student’s Confidence Using Education) campaign was launched. The realization
                        of this initiative has made it possible for many students from underserved communities to come to NCU, find hope, and achieve success.
                        We invite all our readers to support the RESCUE programme by visiting https://www.ncu.edu.jm/donate.
                    </p>
                    <p>
                        At their very core, universities are about the pursuit of new knowledge and
                        so research activities are ongoing at NCU. Additionally, the NCU administration
                        has formed several new partnerships with entities such as Zyva Technology Solutions
                        Jamaica Ltd, Jamaica Small Business Development Corporation and AgroInvest, in support
                        of the growth and development of the University. Partnerships with overseas universities
                        such as Brandon and Brock Universities in Canada, allow for NCU to achieve its internationalization
                        objectives and provide exposure and academic opportunities for our workers and students through exchange programmes.
                    </p>
                    <p>
                        Furthermore, to assist youths from disenfranchised communities, we are partnering with the
                        Inter-American Division of Seventh-day Adventists to develop NCU Centres of Influence. Also,
                        to increase our enrolment, we currently have authorization from the United States Department of
                        Housing and Urban Development to allow US veterans to use their financial aid to attend NCU.
                    </p>
                    <p>
                        Exciting things are happening at NCU! We are confident that under God, this Beacon on the Hill will
                        continue to shine hope in the hearts of all who are touched by her rays. Please join us so that
                        together we can achieve the mission of improving the human condition,
                        and equipping each person for committed, professional service to all people and to God.
                    </p>
                    <div class="uk-align-right" >
                        <h3 class="uk-heading-divider ">Lincoln Edwards</h3>
                        <h5 class="uk-margin-remove-top" style="font-style: italic">President, Northern Caribbean University</h5>
                    </div>
                    <br><br><br><br><br>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PresidentMessage"
    }
</script>

<style scoped>
    p{
        font-size: 18px;
    }
    img{
        border-radius: 15px;
    }
</style>